import DropTargetWrapperContainer from '../../../../containers/dnd/DropTargetWrapperContainer'
import PushCreateDragSwitch from './PushCreateDragSwitch'
import { AD, HIGHLIGHT, MOVIE } from '../../../../constants/itemTypes'

const PushAttachmentDropZone = ({ attachedItem, displayDropzones, basicUrl, linkData, onAdd, onDelete }) => {
    if (displayDropzones) {
        return (
            <DropTargetWrapperContainer
                listID="list-push-attachment"
                items={[]}
                selectionType="newsletter"
                pushItem={(listId, itemId, itemType) => onAdd(listId, itemId, itemType)}
                dndType={[MOVIE, AD, HIGHLIGHT]}
            >
                <div className="periode-item-dropbox">
                    <div className="periode-item-dropbox-inner"></div>
                </div>
            </DropTargetWrapperContainer>
        )
    }

    if (!attachedItem) {
        return null
    }

    return (
        <div className="item-drag-container">
            <ul className="grid-container">
                <li className="item-drag">
                    <PushCreateDragSwitch
                        itemId={attachedItem.itemId}
                        itemType={attachedItem.itemType}
                        itemData={attachedItem.item}
                        linkData={linkData}
                        basicUrl={basicUrl}
                        canEdit={false}
                        canDelete={true}
                        deleteItem={() => onDelete()}
                    />
                </li>
            </ul>
        </div>
    )
}

export default PushAttachmentDropZone
